module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/1cover"
    }
  }, [_vm._v("THE FAT WOMAN’S JOKE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/4start#chap1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/5chap2#chap2"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/6chap3#chap3"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/7chap4#chap4"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/8chap5#chap5"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/9chap6#chap6"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/10chap7#chap7"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/11chap8#chap8"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/12chap9#chap9"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/13chap10#chap10"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/14chap11#chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/15chap12#chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/16chap13#chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/17chap14#chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/18chap15#chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/19chap16#chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/1cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DOWN AMONG THE WOMEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/4start#chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Wanda, Scarlet and Byzantia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/5chap2#chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Ask Your Father")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/6chap3#chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 A Certain Sunday")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/7chap4#chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Scarlet is Brought to Bed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/8chap5#chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Susan is Selfish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/9chap6#chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Problems and Solutions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/10chap7#chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Scarlet Shows Off")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/11chap8#chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Scarlet Goes to Market")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/12chap9#chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 On the Move")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/13chap10#chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Sorting Out")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/14chap11#chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Crucifixions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/15chap12#chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Nice People")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/16chap13#chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Solutions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/17chap14#chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Down Among the Women")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/18chap15#chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Down Among the Women")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/1cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GROWING RICH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/4page#chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/5page#chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/6page#chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/7page#chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/8page#chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/9page#chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/10page#chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/11page#chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/12page#chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/13page#chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/14page#chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/15page#chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/16page#chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/17page#chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/18page#chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/19page#chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/20page#chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/21page#chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/22page#chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/23page#chap20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/24page#chap21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/25page#chap22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/1cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DARCY’S UTOPIA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/4start#chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eleanor Darcy is interviewed by Hugo Vansitart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/5chap2#chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valerie Jones is surprised by Joy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/6chap3#chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Valerie Jones’ first interview with Eleanor Darcy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/7chap4#chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valerie gets one or two things wrong")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/8chap5#chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lover at the Gate [1]: Eleanor Darcy’s birth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/9chap6#chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valerie stops work to listen to Hugo’s tape")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/10chap7#chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lover at the Gate [2]: Apricot loses one mother and gains another")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/11chap8#chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valerie leaps to conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/12chap9#chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valerie Jones returns to ask further questions of Eleanor Darcy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/13chap10#chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valerie and Lou manage a conversation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/14chap11#chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lover at the Gate [3]: Apricot Smith marries Bernard Parkin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/15chap12#chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eleanor Darcy speaks to Hugo and Valerie listens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/16chap13#chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valerie suffers from emotions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/17chap14#chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lover at the Gate [4]: Bernard and Ellen’s Catholic months")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/18chap15#chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valerie’s garden interview with Eleanor Darcy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/19chap16#chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valerie ventures out of the Holiday Inn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/20chap17#chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lover at the Gate [5]: Ellen’s Marxist years with Bernard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/21chap18#chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valerie receives a letter from Eleanor Darcy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/22chap19#chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ellen’s Marxist life with Bernard comes to an end")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/23chap20#chap20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hugo’s restaurant interview with Eleanor Darcy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/24chap21#chap21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valerie meets her lover’s wife")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/25chap22#chap22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lover at the Gate [6]: Bernard’s encounter with Nerina")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/26chap23#chap23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hugo’s further interview with Eleanor Darcy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/27chap24#chap24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valerie is shocked")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/28chap25#chap25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lover at the Gate [7] Brenda finds Ellen in a state of enchantment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/29chap26#chap26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A taped telephone interview between Valerie and Eleanor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/30chap27#chap27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valerie misses home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/31chap28#chap28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lover at the Gate [8]: Bernard and Ellen part")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/32chap29#chap29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transcript of Hugo/Eleanor tape")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/33chap30#chap30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lover at the Gate [9]: Eleanor entertains")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/34chap31#chap31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valerie sits up in bed and listens to tape")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/35chap32#chap32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brenda’s letter to Hugo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/36chap33#chap33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lover at the Gate [10]: Julian overdoes it")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/37chap34#chap34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valerie speaks to Belinda")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/38chap35#chap35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lover at the Gate [11]: Eleanor goes to visit Jed and Prune")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/39chap36#chap36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valerie laughs thrice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/40chap37#chap37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lover at the Gate [12]: A disturbance in the economy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/41chap38#chap38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Loves comes to the Holiday Inn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/42chap39#chap39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hugo and Eleanor walk down to the end of the garden")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/43chap40#chap40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valerie observes the birth of a new religion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Comon/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc27d5a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bundle_content.vue
// module id = 66
// module chunks = 0